import keyBy from "lodash/keyBy";
import * as types from "../actions/actionTypes";

import { ITeam } from "../../types/team/Team";
import { ITeamState, InitialState } from "./state";

const getMappedStateWithTeams = (state: ITeamState, teams: ITeam[]) => ({
  ...state,
  map: { ...state.map, ...keyBy(teams, "_id") },
});

const handles: {
  [key: string]: (state: ITeamState, payload: any) => ITeamState;
} = {
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: ITeamState, shift) =>
    getMappedStateWithTeams(state, shift.teams),
  [types.TEAMS_GET_ALL_FULFILLED]: getMappedStateWithTeams,
};

export default function teamReducer(
  state: ITeamState = InitialState.teams,
  action,
): ITeamState {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
